"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCollapsable = void 0;
const react_1 = __importDefault(require("react"));
function useCollapsable({ initialIsOpen = false, } = {}) {
    const [isOpen, setIsOpen] = react_1.default.useState(initialIsOpen);
    const isClosed = react_1.default.useMemo(() => {
        return !isOpen;
    }, [isOpen]);
    const toggle = react_1.default.useCallback(() => {
        return setIsOpen(!isOpen);
    }, [isOpen, setIsOpen]);
    return {
        isClosed,
        isOpen,
        setIsOpen,
        toggle,
    };
}
exports.useCollapsable = useCollapsable;
